import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Timeline from "@/components/Timeline";
import { api } from "@/lib/api";

export default function CalendarStrip({ days: n = 14 }) {
  const nav = useNavigate();
  const [data, setData] = useState(null);
  useEffect(() => {
    Promise.all([api.get("/vehicles"), api.get("/bookings"), api.get("/rentals", { params: { status: "aperto", imported: "false" } }),
      api.get("/maintenances", { params: { status: "programmata,in_corso" } })].map((p) => p.then((r) => r.data).catch(() => [])))
      .then(([vehicles, bookings, rentals, maint]) => setData({ vehicles: vehicles.filter((v) => !v.calendar_hidden), bookings, rentals, maint }));
  }, []);
  if (!data) return <div className="text-sm text-zinc-500 py-4">Caricamento…</div>;
  const start = new Date(); start.setHours(0, 0, 0, 0);
  const days = Array.from({ length: n }, (_, i) => { const d = new Date(start); d.setDate(d.getDate() + i); return d; });
  const items = [
    ...data.bookings.filter((b) => !["annullata", "convertita"].includes(b.status)).map((b) => ({ kind: "booking", id: b.id, vehicle_id: b.vehicle_id, start: b.start, end: b.end, status: b.status, title: b.customer_name || b.code })),
    ...data.rentals.map((r) => ({ kind: "rental", id: r.id, vehicle_id: r.vehicle_id, start: r.actual_start || r.planned_start, end: r.actual_end || r.planned_end, title: r.customer_name || r.code })),
    ...data.maint.map((m) => ({ kind: "maintenance", id: m.id, vehicle_id: m.vehicle_id, start: m.start, end: m.end, title: m.supplier || "Manutenzione" })),
  ].filter((x) => x.vehicle_id && x.start && x.end);
  return (
    <div data-testid="dashboard-calendar-strip">
      <Timeline days={days} vehicles={data.vehicles} items={items}
        onOpen={(it) => nav(it.kind === "booking" ? `/calendario?id=${it.id}` : it.kind === "rental" ? `/noleggi/${it.id}` : "/manutenzioni")} />
    </div>
  );
}
